import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-3 mt-auto">
      <div className="text-center text-xs text-gray-500 dark:text-gray-400">
        <p>Created by Jaco Oosthuizen and AI • {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;
